<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17.4268 3.42232C15.5192 1.56518 12.9946 0.5 10.5 0.5C8.00536 0.5 5.4808 1.56518 3.57321 3.42232C1.59152 5.35134 0.5 7.86607 0.5 10.5C0.5 11.6906 0.890625 13.2272 1.96786 16.1049C3.04509 18.9826 5.1875 20.1875 6.09241 20.3844C6.35179 20.4411 6.6558 20.5 6.92857 20.5C7.39859 20.5004 7.86045 20.3772 8.26786 20.1429L8.89286 19.7857C9.56563 19.392 9.76205 18.5299 9.375 17.8504L5.49464 11.0393C5.40218 10.8763 5.2783 10.7333 5.13017 10.6185C4.98205 10.5037 4.81262 10.4195 4.63171 10.3707C4.4508 10.3218 4.262 10.3094 4.07624 10.3341C3.89049 10.3587 3.71147 10.42 3.54955 10.5143L2.93839 10.8714C2.7035 11.009 2.49243 11.1838 2.31339 11.3888C2.29117 11.4149 2.26192 11.434 2.22912 11.444C2.19632 11.4539 2.16137 11.4541 2.12842 11.4447C2.09548 11.4353 2.06594 11.4166 2.04333 11.3909C2.02072 11.3651 2.00599 11.3334 2.00089 11.2996C1.95589 11.0353 1.93171 10.768 1.92857 10.5C1.92857 8.25402 2.86607 6.10357 4.56964 4.44598C6.21429 2.84598 8.37455 1.92857 10.5 1.92857C12.6254 1.92857 14.7857 2.84598 16.4304 4.44598C18.1339 6.10357 19.0714 8.25402 19.0714 10.5C19.0674 10.7681 19.0423 11.0354 18.9964 11.2996C18.9913 11.3334 18.9766 11.3651 18.954 11.3909C18.9314 11.4166 18.9018 11.4353 18.8689 11.4447C18.836 11.4541 18.801 11.4539 18.7682 11.444C18.7354 11.434 18.7062 11.4149 18.6839 11.3888C18.5049 11.1838 18.2938 11.009 18.0589 10.8714L17.4478 10.5143C17.2859 10.42 17.1068 10.3587 16.9211 10.3341C16.7353 10.3094 16.5465 10.3218 16.3656 10.3707C16.1847 10.4195 16.0153 10.5037 15.8672 10.6185C15.719 10.7333 15.5951 10.8763 15.5027 11.0393L11.625 17.8504C11.2379 18.5299 11.4344 19.392 12.1071 19.7857L12.7321 20.1429C13.1396 20.3772 13.6014 20.5004 14.0714 20.5C14.3442 20.5 14.6482 20.4411 14.9076 20.3844C15.8125 20.1875 17.9554 18.9821 19.0321 16.1049C20.1089 13.2277 20.5 11.6906 20.5 10.5C20.5 7.86607 19.4085 5.35134 17.4268 3.42232Z"
				:fill="color" 
            />
		</svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgHeadphones',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>